import { computed, input } from '@angular/core';
import * as i0 from "@angular/core";
function AlertConfirmationDetailsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.details().error);
} }
function AlertConfirmationDetailsComponent_Conditional_1_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r0.details().object_type_label, ")");
} }
function AlertConfirmationDetailsComponent_Conditional_1_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "Alert type:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().alert_type_label);
} }
function AlertConfirmationDetailsComponent_Conditional_1_Conditional_7_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "Current condition:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().current_description, " ");
} }
function AlertConfirmationDetailsComponent_Conditional_1_Conditional_7_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "New condition:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().description);
} }
function AlertConfirmationDetailsComponent_Conditional_1_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AlertConfirmationDetailsComponent_Conditional_1_Conditional_7_Conditional_0_Template, 4, 1, "div", 2);
    i0.ɵɵconditionalCreate(1, AlertConfirmationDetailsComponent_Conditional_1_Conditional_7_Conditional_1_Template, 4, 1, "div", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.details().current_description ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasCondition() ? 1 : -1);
} }
function AlertConfirmationDetailsComponent_Conditional_1_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "Condition:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().description);
} }
function AlertConfirmationDetailsComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵdomElementEnd();
    i0.ɵɵconditionalCreate(5, AlertConfirmationDetailsComponent_Conditional_1_Conditional_5_Template, 2, 1, "span");
    i0.ɵɵdomElementEnd();
    i0.ɵɵconditionalCreate(6, AlertConfirmationDetailsComponent_Conditional_1_Conditional_6_Template, 4, 1, "div", 2);
    i0.ɵɵconditionalCreate(7, AlertConfirmationDetailsComponent_Conditional_1_Conditional_7_Template, 2, 2)(8, AlertConfirmationDetailsComponent_Conditional_1_Conditional_8_Template, 4, 1, "div", 2);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.actionLabel(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.details().object_name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().object_type_label ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().alert_type_label ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isEdit() ? 7 : ctx_r0.hasCondition() ? 8 : -1);
} }
const ACTION_LABELS = {
    create: 'Create alert on',
    edit: 'Edit alert on',
    delete: 'Delete alert on',
};
export class AlertConfirmationDetailsComponent {
    constructor() {
        this.details = input.required(...(ngDevMode ? [{ debugName: "details" }] : []));
        this.actionLabel = computed(() => ACTION_LABELS[this.details().action], ...(ngDevMode ? [{ debugName: "actionLabel" }] : []));
        this.hasCondition = computed(() => {
            const details = this.details();
            return !!details.description && details.description !== details.alert_type_label;
        }, ...(ngDevMode ? [{ debugName: "hasCondition" }] : []));
        this.isEdit = computed(() => this.details().action === 'edit', ...(ngDevMode ? [{ debugName: "isEdit" }] : []));
    }
}
AlertConfirmationDetailsComponent.ɵfac = function AlertConfirmationDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AlertConfirmationDetailsComponent)(); };
AlertConfirmationDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AlertConfirmationDetailsComponent, selectors: [["ycn-alert-confirmation-details"]], inputs: { details: [1, "details"] }, decls: 2, vars: 1, consts: [[1, "text-large", "leading-relaxed", "mb-3", "text-red"], [1, "text-large", "leading-relaxed", "mb-3"], [1, "mt-2"], [1, "text-bold"]], template: function AlertConfirmationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AlertConfirmationDetailsComponent_Conditional_0_Template, 2, 1, "div", 0)(1, AlertConfirmationDetailsComponent_Conditional_1_Template, 9, 5, "div", 1);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.details().error ? 0 : 1);
    } }, encapsulation: 2, changeDetection: 0 });
